import ParkPassAPI from "../parkpassAxiosConfig";

export const getAdminCMIPayments = async (params = {}) => {
  try {
    const {
      page = 1,
      pageSize = 25,
      statusFilter,
      productType,
      userId,
      search,
      dateFrom,
      dateTo,
    } = params;

    const queryParams = { page, page_size: pageSize };
    if (statusFilter) queryParams.status_filter = statusFilter;
    if (productType) queryParams.product_type = productType;
    if (userId) queryParams.user_id = userId;
    if (search) queryParams.search = search;
    if (dateFrom) queryParams.date_from = dateFrom;
    if (dateTo) queryParams.date_to = dateTo;

    const response = await ParkPassAPI.get("/v1/wallet/admin/cmi", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
